import OneTapScript from './OneTapScript'

export default OneTapScript
